












import { Component } from 'vue-property-decorator'
import UstraComponent from '@ustra/nuxt/src/vue/components/ustra-component'
import layoutDataEventBus from '@hds/help-common/src/event-bus/layout-data-event-bus'
@Component({
  name: 'EsPageLayout',
})
export default class extends UstraComponent {
  // #region variables
  layoutTitle: string = ''
  layoutType: string = ''
  options: any = ''
  // #endregion
  // #region hooks
  created() {
    layoutDataEventBus.on((state) => {
      this.layoutTitle = state.title
      this.layoutType = state.layoutType || 'type1'
      this.options = state.options
    })
  }
  // #endregion
  // #region methods
  // #endregion
  // #region watches
  // #endregion
}
